module.exports = "<div class=\"cli-view\">\n    <div class=\"cli-command-container\">{{jfCliView.snippet}}</div>\n    <jf-clip-copy text-to-copy=\"jfCliView.snippet\"\n                  object-name=\"Command\"></jf-clip-copy>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/xray/directives/jf_cli_view/jf_cli_view.html
// module id = 551
// module chunks = 9